var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',_vm._g({attrs:{"name":"panel"}},_vm.$listeners),[(_vm.isOpen)?_c('div',{staticClass:"panel-content"},[_vm._t("default",null,{"setPanel":_vm.setPanel})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }